<template>
  <page-layout title="회원관리">
    <template v-slot:content>
      <v-sheet class="d-flex justify-space-between px-2" width="100vw" height="79vh">
        <organization-chart
          :org-list="orgList"
          @select="showSelect"
          @delete="showDelete"
          @refresh="refreshData"
        />
        <organization-info
          :is-show-select="isShowSelect"
          :is-show-delete="isShowDelete"
          :selected-data="selectedData"
          @refresh="refreshData"
        />
      </v-sheet>
    </template>
  </page-layout>
</template>

<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import OrganizationChart from "@/pages/Member/components/MemberManage/OrganizationChart.vue";
import OrganizationInfo from "@/pages/Member/components/MemberManage/OrganizationInfo.vue";
import func from "@/util/func";
import {mapGetters} from "vuex";

export default {
  name: "MemberManage",
  components: {PageLayout, OrganizationChart, OrganizationInfo},
  data() {
    return {
      orgList: [],
      selectedData: {},
      isShowSelect: true,
      isShowDelete: false
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData",
      isAdmin: "isAdmin"
    })
  },
  mounted() {
    this.setOrgList();
  },
  methods: {
    async setOrgList() {
      const orgCd = this.isAdmin ? "" : this.userData.orgCd;
      this.orgList = await func.getOrgList(orgCd, "Y", "Y", "");
    },
    showSelect(item) {
      this.selectedData = item;
      this.isShowSelect = true;
    },
    refreshData() {
      this.setOrgList();
    },
    showDelete() {
      this.isShowDelete = true;
      this.isShowSelect = false;
    }
  }
}
</script>

<style scoped>

</style>